class Api {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.csrf = document.getElementsByName('csrfmiddlewaretoken')[0].value
    })
  }

  async request(path, opts) {
    const response = await fetch(path, opts)
    return response.status !== 500 ? response : ''
  }

  async post(path, opts) {
    const result = await this.request(path, {
      ...opts,
      method: 'POST',
      headers: { 'X-CSRFToken': this.csrf },
    })
    return result.status === 502 ? result : result.json()
  }

  async get(path, opts) {
    const result = await this.request(path, opts)
    return result.json()
  }

  async toggleFav(status, id) {
    return this.request(`/api/${status ? 'unfav' : 'fav'}/${id}/`)
  }

  getQS(model) {
    return (
      '?' +
      new URLSearchParams(
        Object.fromEntries(
          Object.entries(model).filter(
            ([key, value]) =>
              value !== null && (!Array.isArray(value) || value.length > 0)
          )
        )
      )
    )
  }

  async getFeedbackForm(path) {
    const result = await this.request(path)

    if (result.status === 200) {
      return result.text()
    } else {
      console.error('Failed to fetch feedback form:', result)
      return null
    }
  }

  async submitFeedbackForm(path, data) {
    const response = await this.request(path, {
      method: 'POST',
      body: data,
      headers: { 'X-CSRFToken': this.csrf },
    })

    if (response.status === 200) {
      return response.text()
    } else {
      console.error('Failed to submit feedback form:', response)
      return null
    }
  }
}

export default new Api()
